module.exports = __webpack_public_path__ + "img/Steor-Icon-10.68bef5a9.svg";